import { Observable } from './rxjs';
import { traceableAjaxGet, traceableAjaxPost, traceableAjaxPut, traceableAjaxDelete } from './traceableAjax';

export const ajax = Observable.ajax;
export const get = traceableAjaxGet;
export const post = traceableAjaxPost;
export const put = traceableAjaxPut;
export const doDelete = traceableAjaxDelete;
